/* ==========================================================================
   BACKDROPS — canvas-painted scene murals per room, faithful to the
   original 2D rooms. Returned as <canvas>; the 3D engine wraps each in a
   texture and hangs it on the hall's end walls. No THREE dependency.
   ========================================================================== */
(function(){
"use strict";
const W=1280, H=720;
function cv(){ const c=document.createElement('canvas'); c.width=W; c.height=H; return c; }
function grad(x,stops,x0,y0,x1,y1){ const g=x.createLinearGradient(x0,y0,x1,y1); stops.forEach(([o,c])=>g.addColorStop(o,c)); return g; }
function rgrad(x,cx,cy,r,stops){ const g=x.createRadialGradient(cx,cy,0,cx,cy,r); stops.forEach(([o,c])=>g.addColorStop(o,c)); return g; }

const P={
  /* ---- Kyoto Zen / Ryokan: shoji screen ---- */
  shoji(x,theme,room){
    x.fillStyle=room==='ryokan'?'#efe9dc':'#eef2ea'; x.fillRect(0,0,W,H);
    // warm paper glow
    x.fillStyle=rgrad(x,W*0.5,H*0.34,W*0.6,[[0,'rgba(255,245,215,.55)'],[1,'rgba(255,245,215,0)']]); x.fillRect(0,0,W,H);
    // wood lattice
    x.strokeStyle=room==='ryokan'?'#b59a6e':'#bcae8e'; x.lineWidth=7;
    const cols=8, rows=5;
    for(let i=0;i<=cols;i++){ x.beginPath(); x.moveTo(i*W/cols,0); x.lineTo(i*W/cols,H); x.stroke(); }
    for(let j=0;j<=rows;j++){ x.beginPath(); x.moveTo(0,j*H/rows); x.lineTo(W,j*H/rows); x.stroke(); }
    // wood posts at sides
    x.fillStyle=grad(x,[[0,'#6e4f30'],[.5,'#8a6840'],[1,'#6e4f30']],0,0,40,0);
    x.fillRect(0,0,46,H); x.fillRect(W-46,0,46,H);
    // top beam
    x.fillStyle=grad(x,[[0,'#6e4f30'],[1,'#4f3820']],0,0,0,40); x.fillRect(0,0,W,46);
    if(room==='ryokan'){ // hanging lantern
      x.fillStyle=rgrad(x,W*0.5,H*0.22,90,[[0,'#fff0c0'],[.5,'#ffd98a'],[1,'rgba(224,168,0,0)']]);
      x.beginPath(); x.ellipse(W*0.5,H*0.22,60,74,0,0,7); x.fill();
    }
  },
  /* ---- Parisian casement window ---- */
  casement(x,theme){
    x.fillStyle='#eceae3'; x.fillRect(0,0,W,H);
    x.fillStyle=grad(x,[[0,'#f4f2ec'],[1,'#d4cfc2']],0,0,0,60); x.fillRect(0,0,W,54); // crown
    // window opening
    const wx=W*0.22,wy=H*0.12,ww=W*0.56,wh=H*0.66;
    x.fillStyle='#f4f2ec'; x.fillRect(wx-22,wy-22,ww+44,wh+44);
    x.fillStyle=grad(x,[[0,'#cfe2ee'],[1,'#9fbcd2']],0,wy,0,wy+wh); x.fillRect(wx,wy,ww,wh);
    // Eiffel silhouette
    x.fillStyle='rgba(70,80,70,.45)'; x.save(); x.translate(wx+ww*0.62,wy+wh*0.9); 
    x.beginPath(); x.moveTo(-46,0); x.lineTo(-10,-wh*0.78); x.lineTo(10,-wh*0.78); x.lineTo(46,0); x.closePath(); x.fill();
    x.fillRect(-8,-wh*0.8,16,-10); x.restore();
    // mullions
    x.fillStyle='#f4f2ec'; x.fillRect(wx+ww/2-9,wy,18,wh); x.fillRect(wx,wy+wh/2-9,ww,18);
    // floor lamp glow bottom-left
    x.fillStyle=rgrad(x,W*0.12,H*0.86,150,[[0,'rgba(255,235,180,.5)'],[1,'rgba(255,235,180,0)']]); x.fillRect(0,H*0.5,W*0.4,H*0.5);
  },
  /* ---- Santorini sunset ---- */
  santorini(x){
    x.fillStyle=grad(x,[[0,'#3a4a96'],[.26,'#8a6fbe'],[.56,'#e8765f'],[.78,'#ffce72'],[1,'#ffe9b0']],0,0,0,H); x.fillRect(0,0,W,H);
    // sun
    x.fillStyle=rgrad(x,W*0.5,H*0.52,140,[[0,'#fff6d8'],[.6,'#ffcf6e'],[1,'rgba(255,207,110,0)']]); x.beginPath(); x.arc(W*0.5,H*0.52,150,0,7); x.fill();
    // sea
    x.fillStyle=grad(x,[[0,'#e9a06a'],[.28,'#bf6f90'],[.66,'#5a5fae'],[1,'#2d3f86']],0,H*0.72,0,H); x.fillRect(0,H*0.72,W,H*0.28);
    // white terrace + blue dome church
    x.fillStyle='#fbf7ef'; x.beginPath(); x.moveTo(0,H*0.55); x.lineTo(W*0.34,H*0.48); x.lineTo(W*0.34,H); x.lineTo(0,H); x.closePath(); x.fill();
    x.fillStyle=grad(x,[[0,'#2f6fb0'],[1,'#16467e']],0,H*0.42,0,H*0.62); 
    x.beginPath(); x.ellipse(W*0.16,H*0.5,70,54,0,Math.PI,0); x.fill(); x.fillRect(W*0.16-70,H*0.5,140,90);
    x.fillStyle='#fff'; x.fillRect(W*0.16-6,H*0.36,12,40); // cross post
    // sailboat
    x.fillStyle='#2a2a3a'; x.beginPath(); x.moveTo(W*0.7,H*0.86); x.lineTo(W*0.74,H*0.86); x.lineTo(W*0.72,H*0.8); x.closePath(); x.fill();
  },
  /* ---- Miami poolside ---- */
  miami(x){
    x.fillStyle=grad(x,[[0,'#ff8fb0'],[.4,'#ffd98a'],[1,'#7fd8f0']],0,0,0,H); x.fillRect(0,0,W,H);
    x.fillStyle=rgrad(x,W*0.66,H*0.26,130,[[0,'#fff6d8'],[.7,'#ff9a5c'],[1,'rgba(255,154,92,0)']]); x.beginPath(); x.arc(W*0.66,H*0.26,150,0,7); x.fill();
    // palms
    function palm(px,py,hh){ x.strokeStyle='#5a4030'; x.lineWidth=18; x.beginPath(); x.moveTo(px,py); x.quadraticCurveTo(px+20,py-hh*0.5,px+6,py-hh); x.stroke();
      x.fillStyle='#2f7a45'; for(let a=-2;a<=2;a++){ x.save(); x.translate(px+6,py-hh); x.rotate(a*0.5); x.beginPath(); x.ellipse(70,0,80,16,0,0,7); x.fill(); x.restore(); } }
    palm(W*0.12,H*0.74,H*0.5); palm(W*0.86,H*0.74,H*0.46);
    // deck + pool
    x.fillStyle=grad(x,[[0,'#f0e6d2'],[1,'#d8c9a8']],0,H*0.74,0,H*0.84); x.fillRect(0,H*0.74,W,H*0.1);
    x.fillStyle=grad(x,[[0,'#2fb8d8'],[1,'#1a7a9a']],0,H*0.84,0,H); x.fillRect(0,H*0.84,W,H*0.16);
    x.strokeStyle='rgba(255,255,255,.25)'; x.lineWidth=3; for(let i=0;i<W;i+=46){ x.beginPath(); x.moveTo(i,H*0.9); x.lineTo(i+24,H); x.stroke(); }
  },
  /* ---- Thai temple ---- */
  thai(x,theme){
    x.fillStyle=grad(x,[[0,'#241a3a'],[1,'#3a2150']],0,0,0,H); x.fillRect(0,0,W,H);
    // tiered roofs
    function roof(cx,top,wd,ht,c1,c2){ x.fillStyle=grad(x,[[0,c1],[1,c2]],0,top,0,top+ht); x.beginPath(); x.moveTo(cx-wd,top+ht); x.lineTo(cx-wd*0.12,top+ht*0.5); x.lineTo(cx,top); x.lineTo(cx+wd*0.12,top+ht*0.5); x.lineTo(cx+wd,top+ht); x.closePath(); x.fill();
      x.strokeStyle='rgba(232,191,74,.6)'; x.lineWidth=3; x.stroke(); }
    roof(W*0.5,H*0.04,W*0.42,H*0.16,'#b3382b','#7a2418');
    roof(W*0.5,H*0.16,W*0.32,H*0.13,'#c9402f','#8a2a1c');
    // columns
    x.fillStyle=grad(x,[[0,'#7a4a1c'],[.5,'#caa14a'],[1,'#7a4a1c']],W*0.13,0,W*0.19,0);
    x.fillRect(W*0.13,H*0.3,W*0.06,H*0.5); x.fillRect(W*0.81,H*0.3,W*0.06,H*0.5);
    // buddha glow
    x.fillStyle=rgrad(x,W*0.5,H*0.66,90,[[0,'rgba(232,191,74,.5)'],[1,'rgba(232,191,74,0)']]); x.beginPath(); x.arc(W*0.5,H*0.66,100,0,7); x.fill();
  },
  /* ---- Moroccan keyhole arch ---- */
  morocco(x,theme){
    x.fillStyle='#0b3346'; x.fillRect(0,0,W,H);
    // zellige border
    const s=W/16; const cols=['#0d3c52','#12597a','#0a2c3d','#1d7aa0'];
    for(let r=0;r<H/s+1;r++)for(let c=0;c<16;c++){ if(c<2||c>13||r<1||r>H/s-2){ x.fillStyle=cols[(r+c)%4]; x.fillRect(c*s,r*s,s,s); x.strokeStyle='rgba(201,162,74,.4)'; x.strokeRect(c*s,r*s,s,s);} }
    // keyhole arch opening to night
    const ax=W*0.27,aw=W*0.46,atop=H*0.1,abot=H*0.92;
    x.fillStyle=grad(x,[[0,'#0a1626'],[1,'#06212f']],0,atop,0,abot);
    x.beginPath(); x.moveTo(ax,abot); x.lineTo(ax,atop+aw*0.5); x.arc(ax+aw*0.5,atop+aw*0.5,aw*0.5,Math.PI,0); x.lineTo(ax+aw,abot); x.closePath(); x.fill();
    x.lineWidth=8; x.strokeStyle='#c9a24a'; x.stroke();
    // stars in arch
    x.fillStyle='#cfe0ff'; for(let i=0;i<40;i++){ x.beginPath(); x.arc(ax+10+Math.random()*(aw-20),atop+20+Math.random()*(abot-atop-40),1.5,0,7); x.fill(); }
    // hanging lanterns
    [W*0.18,W*0.82].forEach(lx=>{ x.fillStyle=rgrad(x,lx,H*0.16,60,[[0,'#ffe6a8'],[.5,'#e8b34a'],[1,'rgba(232,179,74,0)']]); x.beginPath(); x.arc(lx,H*0.16,64,0,7); x.fill(); });
    // rug strip
    x.fillStyle=grad(x,[[0,'#b3382b'],[.33,'#e0a93f'],[.66,'#0e5577'],[1,'#e0a93f']],0,0,W,0); x.fillRect(W*0.13,H*0.93,W*0.74,H*0.07);
  },
  /* ---- Grand Opera ---- */
  opera(x,theme){
    x.fillStyle=grad(x,[[0,'#3a0c18'],[1,'#1a0408']],0,0,0,H); x.fillRect(0,0,W,H);
    // gold valance
    x.fillStyle=grad(x,[[0,'#e8bf4a'],[1,'#a07a1f']],0,0,0,H*0.12); x.beginPath(); x.moveTo(0,0); x.lineTo(W,0);
    x.lineTo(W,H*0.06); for(let i=10;i>=0;i--){ x.lineTo(W*(i+0.5)/11,H*0.12); x.lineTo(W*i/11,H*0.06);} x.closePath(); x.fill();
    // curtains
    function curtain(cx,flip){ x.save(); if(flip){x.translate(W,0);x.scale(-1,1);} 
      x.fillStyle=grad(x,[[0,'#7a1020'],[.5,'#b3182e'],[1,'#7a1020']],0,0,W*0.2,0); x.fillRect(0,0,W*0.2,H);
      x.strokeStyle='rgba(0,0,0,.3)'; x.lineWidth=6; for(let i=0;i<W*0.2;i+=26){ x.beginPath(); x.moveTo(i,0); x.lineTo(i,H); x.stroke(); } x.restore(); }
    curtain(0,false); curtain(0,true);
    // opera boxes
    [W*0.1,W*0.78].forEach(bx=>{ x.fillStyle=grad(x,[[0,'#5a0c14'],[1,'#2a0408']],0,H*0.24,0,H*0.56); x.fillRect(bx,H*0.24,W*0.12,H*0.3);
      x.strokeStyle='#c9a24a'; x.lineWidth=5; x.strokeRect(bx,H*0.24,W*0.12,H*0.3); });
    // chandelier
    x.fillStyle=rgrad(x,W*0.5,H*0.18,90,[[0,'#ffe9a8'],[.6,'#c9a24a'],[1,'rgba(201,162,74,0)']]); x.beginPath(); x.arc(W*0.5,H*0.18,100,0,7); x.fill();
  },
  /* ---- Space porthole ---- */
  space(x){
    x.fillStyle=rgrad(x,W*0.7,H*0.3,W*0.8,[[0,'#1a1f44'],[.7,'#06060f']]); x.fillRect(0,0,W,H);
    x.fillStyle='#fff'; for(let i=0;i<160;i++){ x.globalAlpha=Math.random()*0.8+0.2; x.beginPath(); x.arc(Math.random()*W,Math.random()*H,Math.random()*1.6,0,7); x.fill(); } x.globalAlpha=1;
    // porthole
    const cx=W*0.5,cy=H*0.46,r=H*0.36;
    x.fillStyle='#243a6a'; x.beginPath(); x.arc(cx,cy,r,0,7); x.fill();
    x.fillStyle=rgrad(x,cx-r*0.3,cy-r*0.3,r,[[0,'#2c4a86'],[1,'#0a0f22']]); x.beginPath(); x.arc(cx,cy,r,0,7); x.fill();
    // planet
    x.fillStyle=rgrad(x,cx+r*0.2,cy-r*0.2,r*0.5,[[0,'#5a7fd0'],[.7,'#1a2f6a']]); x.beginPath(); x.arc(cx+r*0.15,cy,r*0.42,0,7); x.fill();
    // ring bezel
    x.lineWidth=34; x.strokeStyle='#2b3350'; x.beginPath(); x.arc(cx,cy,r+12,0,7); x.stroke();
    x.lineWidth=8; x.strokeStyle='#1a2036'; x.beginPath(); x.arc(cx,cy,r+34,0,7); x.stroke();
  },
  /* ---- Infinity void ---- */
  infinity(x,theme){
    x.fillStyle='#050507'; x.fillRect(0,0,W,H);
    const cx=W*0.5,cy=H*0.42;
    for(let r=H*0.5;r>6;r-=H*0.05){ x.strokeStyle='rgba(0,229,255,'+(0.06+0.5*(1-r/(H*0.5)))+')'; x.lineWidth=2; x.beginPath(); x.arc(cx,cy,r,0,7); x.stroke(); }
    // kusama dots
    x.fillStyle='#00e5ff'; for(let i=0;i<70;i++){ x.globalAlpha=0.18+Math.random()*0.5; const a=Math.random()*7,rr=Math.random()*H*0.55; x.beginPath(); x.arc(cx+Math.cos(a)*rr*1.3,cy+Math.sin(a)*rr,3+Math.random()*5,0,7); x.fill(); } x.globalAlpha=1;
  },
  /* ---- Flower Garden ---- */
  garden(x){
    x.fillStyle=grad(x,[[0,'#a9dcff'],[.55,'#e9f7ff'],[1,'#cdeccd']],0,0,0,H); x.fillRect(0,0,W,H);
    // pergola top
    x.fillStyle='#caa46a'; for(let i=0;i<W;i+=W/12){ x.fillRect(i,0,W/24,H*0.12); }
    // stone wall
    x.fillStyle='#cdbf9a'; x.fillRect(0,H*0.3,W,H*0.32);
    x.strokeStyle='rgba(80,60,30,.18)'; x.lineWidth=2; for(let r=0;r<5;r++){ x.beginPath(); x.moveTo(0,H*0.3+r*H*0.064); x.lineTo(W,H*0.3+r*H*0.064); x.stroke(); }
    // hedge
    x.fillStyle='#3f7a3f'; for(let i=0;i<14;i++){ x.beginPath(); x.arc(W*(i/13),H*0.66,70,0,7); x.fill(); }
    x.fillStyle='#2f5f2f'; x.fillRect(0,H*0.7,W,H*0.3);
    // flowers
    const fc=['#ff5a8a','#ffd23f','#ff8a3f','#c44fd0','#ff3f6b','#ffe08a'];
    for(let i=0;i<40;i++){ x.fillStyle=fc[i%6]; const fx=Math.random()*W,fy=H*0.7+Math.random()*H*0.28; for(let p=0;p<5;p++){ x.beginPath(); x.ellipse(fx+Math.cos(p*1.25)*9,fy+Math.sin(p*1.25)*9,6,4,p,0,7); x.fill(); } x.fillStyle='#ffe08a'; x.beginPath(); x.arc(fx,fy,4,0,7); x.fill(); }
    // butterflies
    x.fillStyle='#ff8a3f'; [[W*0.3,H*0.4],[W*0.7,H*0.32]].forEach(([bx,by])=>{ x.beginPath(); x.ellipse(bx-8,by,8,12,0.5,0,7); x.ellipse(bx+8,by,8,12,-0.5,0,7); x.fill(); });
  },
  /* ---- Enchanted Forest ---- */
  forest(x){
    x.fillStyle=grad(x,[[0,'#0a3018'],[1,'#04140c']],0,0,0,H); x.fillRect(0,0,W,H);
    // canopy blobs
    for(let i=0;i<10;i++){ x.fillStyle=i%2?'#225a32':'#1a4a2a'; x.beginPath(); x.arc(W*(i/9),H*0.16,120,0,7); x.fill(); }
    // sunbeam
    x.fillStyle='rgba(180,255,180,.16)'; x.save(); x.translate(W*0.5,0); x.rotate(0.12); x.fillRect(-90,0,180,H); x.restore();
    // trunks
    x.fillStyle=grad(x,[[0,'#3a2a1a'],[.5,'#5a4030'],[1,'#3a2a1a']],0,0,80,0);
    [W*0.14,W*0.4,W*0.66,W*0.88].forEach(tx=>{ x.fillRect(tx,H*0.1,52,H*0.78); });
    // moss
    x.fillStyle=grad(x,[[0,'#2a5a32'],[1,'#163018']],0,H*0.82,0,H); x.fillRect(0,H*0.82,W,H*0.18);
    // fireflies
    x.fillStyle='#dfff8a'; for(let i=0;i<40;i++){ x.globalAlpha=Math.random(); x.beginPath(); x.arc(Math.random()*W,H*0.2+Math.random()*H*0.6,2+Math.random()*2,0,7); x.fill(); } x.globalAlpha=1;
  },
  /* ---- Florence Casa ---- */
  florence(x){
    x.fillStyle=grad(x,[[0,'#e3cfb0'],[.7,'#cdb088'],[1,'#b9966c']],0,0,0,H); x.fillRect(0,0,W,H);
    // arched window
    const wx=W*0.3,wy=H*0.1,ww=W*0.4,wh=H*0.62;
    x.fillStyle='#c9a86f'; x.fillRect(wx-16,wy-16,ww+32,wh+32);
    x.fillStyle=grad(x,[[0,'#bfd8ea'],[.7,'#7fa9c8'],[1,'#5d86a6']],0,wy,0,wy+wh);
    x.beginPath(); x.moveTo(wx,wy+wh); x.lineTo(wx,wy+ww*0.3); x.arc(wx+ww*0.5,wy+ww*0.3,ww*0.5,Math.PI,0); x.lineTo(wx+ww,wy+wh); x.closePath(); x.fill();
    // tuscan hills
    x.fillStyle='#6f8a52'; x.beginPath(); x.moveTo(wx,wy+wh); x.lineTo(wx,wy+wh*0.7); x.bezierCurveTo(wx+ww*0.3,wy+wh*0.55,wx+ww*0.7,wy+wh*0.62,wx+ww,wy+wh*0.55); x.lineTo(wx+ww,wy+wh); x.fill();
    // cypress
    x.fillStyle='#3a5a32'; [0.3,0.5,0.7].forEach(p=>{ x.beginPath(); x.ellipse(wx+ww*p,wy+wh*0.66,8,30,0,0,7); x.fill(); });
    // mullion cross
    x.fillStyle='#c9a86f'; x.fillRect(wx+ww/2-7,wy,14,wh); x.fillRect(wx,wy+wh*0.42,ww,14);
    // wainscot
    x.fillStyle=grad(x,[[0,'#b98e5e'],[1,'#8f6a40']],0,H*0.78,0,H); x.fillRect(0,H*0.78,W,H*0.22);
    // sconce glows
    [W*0.14,W*0.86].forEach(sx=>{ x.fillStyle=rgrad(x,sx,H*0.22,90,[[0,'rgba(255,210,130,.5)'],[1,'rgba(255,210,130,0)']]); x.beginPath(); x.arc(sx,H*0.22,100,0,7); x.fill(); });
  },
  /* ---- Desert Modernist ---- */
  desert(x){
    x.fillStyle=grad(x,[[0,'#efe3d4'],[1,'#e0cdb6']],0,0,0,H); x.fillRect(0,0,W,H);
    // big glass window onto desert
    const wx=W*0.18,wy=H*0.12,ww=W*0.64,wh=H*0.6;
    x.fillStyle=grad(x,[[0,'#bfe0ef'],[.7,'#e9c79a'],[1,'#caa06e']],0,wy,0,wy+wh); x.fillRect(wx,wy,ww,wh);
    // mountains
    x.fillStyle=grad(x,[[0,'#b07a55'],[1,'#8a5a3a']],0,wy+wh*0.5,0,wy+wh); x.beginPath(); x.moveTo(wx,wy+wh);
    x.lineTo(wx,wy+wh*0.6); x.lineTo(wx+ww*0.2,wy+wh*0.35); x.lineTo(wx+ww*0.4,wy+wh*0.55); x.lineTo(wx+ww*0.6,wy+wh*0.28); x.lineTo(wx+ww*0.8,wy+wh*0.5); x.lineTo(wx+ww,wy+wh*0.32); x.lineTo(wx+ww,wy+wh); x.fill();
    // sun
    x.fillStyle=rgrad(x,wx+ww*0.7,wy+wh*0.3,80,[[0,'#fff3d0'],[1,'rgba(255,186,92,0)']]); x.beginPath(); x.arc(wx+ww*0.7,wy+wh*0.3,90,0,7); x.fill();
    // mullions
    x.fillStyle='#efe3d4'; x.fillRect(wx+ww/3,wy,10,wh); x.fillRect(wx+2*ww/3,wy,10,wh);
    // cactus silhouettes
    x.fillStyle='#5f7a45'; [wx+40,wx+ww-60].forEach(cx=>{ x.fillRect(cx,wy+wh*0.55,22,wh*0.45); x.fillRect(cx-30,wy+wh*0.7,30,12); x.fillRect(cx-30,wy+wh*0.5,12,wh*0.22); });
  },
  /* ---- Bauhaus ---- */
  bauhaus(x){
    x.fillStyle='#f4f1ea'; x.fillRect(0,0,W,H);
    x.fillStyle='#2962ff'; x.fillRect(0,0,W*0.26,H*0.5);
    x.fillStyle='#ffd23f'; x.fillRect(W*0.74,H*0.34,W*0.26,H*0.42);
    x.fillStyle='#ff2e63'; x.fillRect(W*0.1,H*0.55,W*0.14,H*0.3);
    x.fillStyle='#0d0d0d'; x.beginPath(); x.arc(W*0.66,H*0.22,W*0.07,0,7); x.fill();
    x.strokeStyle='#0d0d0d'; x.lineWidth=8; x.beginPath(); x.moveTo(W*0.32,0); x.lineTo(W*0.32,H); x.stroke();
    x.beginPath(); x.moveTo(0,H*0.62); x.lineTo(W,H*0.62); x.stroke();
  },
  /* ---- Brooklyn High-Rise window ---- */
  brooklyn(x){
    // floor-to-ceiling window, sunset over skyline
    x.fillStyle=grad(x,[[0,'#3a2f5a'],[.26,'#6e4d7e'],[.52,'#d9756a'],[.7,'#f2a45c'],[.84,'#f6c98a'],[1,'#34506e']],0,0,0,H); x.fillRect(0,0,W,H);
    // sun
    x.fillStyle=rgrad(x,W*0.66,H*0.46,80,[[0,'#fff3d0'],[.6,'#ffba5c'],[1,'rgba(255,186,92,0)']]); x.beginPath(); x.arc(W*0.66,H*0.46,90,0,7); x.fill();
    // skyline
    x.fillStyle='#1a1726'; let bx=0; while(bx<W){ const bw=20+Math.random()*60,bh=H*(0.2+Math.random()*0.4); x.fillRect(bx,H-bh,bw,bh);
      x.fillStyle='rgba(255,217,138,.7)'; for(let wy2=H-bh+8;wy2<H-8;wy2+=14)for(let wx2=bx+4;wx2<bx+bw-4;wx2+=10){ if(Math.random()>.4) x.fillRect(wx2,wy2,4,7); } x.fillStyle='#1a1726'; bx+=bw+4; }
    // mullions
    x.strokeStyle='#15171f'; x.lineWidth=10; for(let i=1;i<4;i++){ x.beginPath(); x.moveTo(W*i/4,0); x.lineTo(W*i/4,H); x.stroke(); } x.beginPath(); x.moveTo(0,H*0.5); x.lineTo(W,H*0.5); x.stroke();
  },
  /* ---- Cyberpunk Arcade ---- */
  arcade(x){
    x.fillStyle=grad(x,[[0,'#1a0a2e'],[1,'#0a0418']],0,0,0,H); x.fillRect(0,0,W,H);
    // perspective grid floor
    x.strokeStyle='rgba(255,46,99,.6)'; x.lineWidth=2;
    for(let i=-10;i<=10;i++){ x.beginPath(); x.moveTo(W/2,H*0.5); x.lineTo(W/2+i*W*0.12,H); x.stroke(); }
    x.strokeStyle='rgba(0,229,255,.5)'; for(let j=0;j<8;j++){ const yy=H*0.5+ (H*0.5)*(j/8)*(j/8); x.beginPath(); x.moveTo(0,yy); x.lineTo(W,yy); x.stroke(); }
    // glow
    x.fillStyle=rgrad(x,W*0.5,H*0.4,W*0.5,[[0,'rgba(0,229,255,.18)'],[1,'rgba(0,229,255,0)']]); x.fillRect(0,0,W,H);
    // neon signs
    x.font='italic 900 90px Georgia'; x.textAlign='center';
    x.fillStyle='#ff2e63'; x.shadowColor='#ff2e63'; x.shadowBlur=30; x.fillText('DREAM',W*0.28,H*0.28);
    x.fillStyle='#00e5ff'; x.shadowColor='#00e5ff'; x.fillText('BLOOM',W*0.74,H*0.6); x.shadowBlur=0;
    // neon tubes
    x.fillStyle='#00e5ff'; x.shadowColor='#00e5ff'; x.shadowBlur=18; x.fillRect(W*0.16,0,8,H); x.fillRect(W*0.82,0,8,H); x.shadowBlur=0;
  },
  /* ---- Scottish Castle ---- */
  castle(x){
    // stone wall
    x.fillStyle='#4a5159'; x.fillRect(0,0,W,H);
    x.strokeStyle='rgba(0,0,0,.25)'; x.lineWidth=3;
    for(let r=0;r<10;r++){ const off=r%2?40:0; for(let c=-1;c<14;c++){ x.strokeRect(c*100+off,r*H*0.1,100,H*0.1); } }
    // arched window with sky
    const wx=W*0.08,wy=H*0.08,ww=W*0.26,wh=H*0.5;
    x.fillStyle=grad(x,[[0,'#a7caea'],[1,'#5a7fae']],0,wy,0,wy+wh);
    x.beginPath(); x.moveTo(wx,wy+wh); x.lineTo(wx,wy+ww*0.5); x.arc(wx+ww*0.5,wy+ww*0.5,ww*0.5,Math.PI,0); x.lineTo(wx+ww,wy+wh); x.fill();
    x.lineWidth=10; x.strokeStyle='#3a4149'; x.stroke();
    x.fillStyle='#3a4149'; x.fillRect(wx+ww/2-6,wy,12,wh);
    // banner
    x.fillStyle=grad(x,[[0,'#1a3a7a'],[1,'#0a1f4a']],0,H*0.06,0,H*0.5); x.beginPath(); x.moveTo(W*0.72,H*0.06); x.lineTo(W*0.86,H*0.06); x.lineTo(W*0.86,H*0.42); x.lineTo(W*0.79,H*0.5); x.lineTo(W*0.72,H*0.42); x.fill();
    x.strokeStyle='#e8bf4a'; x.lineWidth=3; x.stroke();
    // hearth glow bottom center
    x.fillStyle=rgrad(x,W*0.5,H,180,[[0,'rgba(255,120,42,.5)'],[1,'rgba(255,120,42,0)']]); x.beginPath(); x.arc(W*0.5,H,200,0,7); x.fill();
    // torch glows
    [W*0.36,W*0.64].forEach(tx=>{ x.fillStyle=rgrad(x,tx,H*0.3,70,[[0,'rgba(255,178,74,.6)'],[1,'rgba(255,90,42,0)']]); x.beginPath(); x.arc(tx,H*0.3,80,0,7); x.fill(); });
  },
  /* ---- Gothic Cathedral ---- */
  cathedral(x){
    x.fillStyle=grad(x,[[0,'#1a1a2a'],[1,'#0a0a14']],0,0,0,H); x.fillRect(0,0,W,H);
    // rose window
    const cx=W*0.5,cy=H*0.26,r=H*0.2;
    const cols=['#b3182e','#c9a24a','#2962ff','#3fffb0','#9b5fff'];
    for(let k=0;k<12;k++){ x.fillStyle=cols[k%5]; x.beginPath(); x.moveTo(cx,cy); x.arc(cx,cy,r,k*Math.PI/6,(k+1)*Math.PI/6); x.closePath(); x.fill(); }
    x.fillStyle='#2a2418'; x.beginPath(); x.arc(cx,cy,r*0.3,0,7); x.fill();
    x.lineWidth=8; x.strokeStyle='#2a2418'; x.beginPath(); x.arc(cx,cy,r,0,7); x.stroke();
    // pointed arches
    [W*0.14,W*0.86].forEach(ax=>{ x.fillStyle='#15151f'; x.beginPath(); x.moveTo(ax-W*0.06,H); x.lineTo(ax-W*0.06,H*0.4); x.lineTo(ax,H*0.24); x.lineTo(ax+W*0.06,H*0.4); x.lineTo(ax+W*0.06,H); x.fill(); });
    // lancet windows (blue/purple glow)
    [W*0.3,W*0.7].forEach(lx=>{ x.fillStyle=grad(x,[[0,'#2962ff'],[1,'#9b5fff']],0,H*0.4,0,H*0.8); x.beginPath(); x.moveTo(lx-30,H*0.8); x.lineTo(lx-30,H*0.5); x.lineTo(lx,H*0.4); x.lineTo(lx+30,H*0.5); x.lineTo(lx+30,H*0.8); x.fill(); });
    // candle glows
    for(let i=0;i<6;i++){ x.fillStyle=rgrad(x,W*(0.2+i*0.12),H*0.9,40,[[0,'rgba(255,200,120,.6)'],[1,'rgba(255,200,120,0)']]); x.beginPath(); x.arc(W*(0.2+i*0.12),H*0.9,44,0,7); x.fill(); }
  },
  /* ---- Aurora Cabin ---- */
  aurora(x){
    x.fillStyle=grad(x,[[0,'#04101f'],[1,'#020812']],0,0,0,H); x.fillRect(0,0,W,H);
    // stars
    x.fillStyle='#fff'; for(let i=0;i<120;i++){ x.globalAlpha=Math.random(); x.beginPath(); x.arc(Math.random()*W,Math.random()*H*0.6,Math.random()*1.4,0,7); x.fill(); } x.globalAlpha=1;
    // aurora bands
    x.save(); x.globalAlpha=0.6;
    let g1=x.createLinearGradient(0,0,W,0); g1.addColorStop(0,'transparent'); g1.addColorStop(0.5,'#3fffb0'); g1.addColorStop(0.7,'#2962ff'); g1.addColorStop(1,'transparent');
    x.fillStyle=g1; x.beginPath(); x.moveTo(0,H*0.1); x.bezierCurveTo(W*0.3,H*0.02,W*0.6,H*0.22,W,H*0.08); x.lineTo(W,H*0.26); x.bezierCurveTo(W*0.6,H*0.4,W*0.3,H*0.2,0,H*0.28); x.fill();
    let g2=x.createLinearGradient(0,0,W,0); g2.addColorStop(0,'transparent'); g2.addColorStop(0.4,'#9b5fff'); g2.addColorStop(0.6,'#00e5ff'); g2.addColorStop(1,'transparent');
    x.fillStyle=g2; x.beginPath(); x.moveTo(0,H*0.24); x.bezierCurveTo(W*0.4,H*0.16,W*0.7,H*0.36,W,H*0.22); x.lineTo(W,H*0.4); x.bezierCurveTo(W*0.7,H*0.52,W*0.4,H*0.34,0,H*0.42); x.fill();
    x.restore();
    // snowy ground + pines
    x.fillStyle=grad(x,[[0,'#dfeaf2'],[1,'#aebfce']],0,H*0.72,0,H); x.fillRect(0,H*0.72,W,H*0.28);
    x.fillStyle='#1a2a22'; for(let i=0;i<8;i++){ const px=W*(i/7); x.beginPath(); x.moveTo(px,H*0.74); x.lineTo(px-30,H*0.74); x.lineTo(px,H*0.5); x.lineTo(px+30,H*0.74); x.fill(); }
    // fire glow
    x.fillStyle=rgrad(x,W*0.28,H,150,[[0,'rgba(255,140,60,.5)'],[1,'rgba(255,140,60,0)']]); x.beginPath(); x.arc(W*0.28,H,160,0,7); x.fill();
  }
};

window.Backdrops={
  paint(roomId,theme){
    const c=cv(), x=c.getContext('2d');
    const fn=P[theme.scene]||P.shoji;
    fn(x,theme,roomId);
    return c;
  }
};
})();